module.exports = __webpack_public_path__ + "img/resumes.4ff0381d.svg";